import { BadgeInfo } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Icon } from './Icon';

export function Tooltip({ info, icon = BadgeInfo, align = 'left' }: { info: string; icon?: LucideIcon; align?: 'left' | 'right' }) {
	return (
		<div className="group/tooltip relative ml-1">
			<Icon className="size-4 cursor-pointer text-gray-500 dark:text-gray-300" icon={icon} />

			<div
				className={`absolute bottom-full z-10 mb-2 hidden w-max max-w-xs rounded-md bg-gray-800/80 p-2 text-xs text-white shadow-lg group-hover/tooltip:block ${align === 'left' ? '-left-2' : '-right-2'}`}
			>
				{info}
				<div
					className={`absolute -bottom-2 size-0 border-x-8 border-t-8 border-x-transparent border-t-gray-800/80 ${align === 'left' ? 'left-2' : 'right-2'}`}
				/>
			</div>
		</div>
	);
}
